import React, { useEffect, useMemo, useState } from 'react';
import {
  Button,
  Grid,
  InputAdornment,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import { AppActions } from 'src/store/AppReducer';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import validator from 'validator';
import { useForm } from 'react-hook-form';
import { createStakeHolder } from 'src/services/projectService';
import SearchIcon from '@mui/icons-material/Search';
import { RootStateType } from 'src/store/RootReducer';
import MuiPhoneNumber from 'material-ui-phone-number';
export interface StakeholderInformation {
  name: string;
  designation: string;
  email: string;
  contact: string;
  segment: string;
  customer: string;
}

const AddStakeHolder = ({
  toggle,
  open,
  getData,
  length,
  segments,
  setSnackBarOpen,
  setSnackbarSeverity,
  setSnackBarMessage
}) => {
  const dispatch = useDispatch();
  const TextFieldStyle = {
    paddingTop: 2,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const LabelStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const selectStyle = {
    width: '94%',
    marginLeft: 15,
    marginTop: 5,
    paddingRight: 15,
    fontSize: '13px'
  };

  const { register, handleSubmit, reset } = useForm<StakeholderInformation>();

  const [nameError, setNameError] = useState('');
  const [designationError, setDesignationError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [contactError, setContactError] = useState('');
  const [segmentError, setSegmentError] = useState('');
  const [customerError, setCustomerError] = useState('');
  const [customers, setCustomers] = useState([]);
  const [segment, setSegment] = useState('');

  const [contactNumber, setContactNumber] = useState('');

  useEffect(() => {
    setCustomers(segments.filter((seg) => seg.id === segment)[0]?.customers);
  }, [segment, segments]);

  const onClose = () => {
    reset();
    setContactNumber('');
    setCustomerValue('');
    setSelectedOption('');
    setContactError('');
    toggle();
    onClearErrorMessages();
  };

   //clear inline error messages
   const onClearErrorMessages = ( () => {
    setNameError('');
    setDesignationError('');
    setEmailError('');
    setContactError('');
    setSegmentError('');
    setCustomerError('');
  })

  const useAppSelector: TypedUseSelectorHook<RootStateType> = useSelector;
  const { isLoading } = useAppSelector((state) => state.appReducer);

  const onSubmit = (data: StakeholderInformation) => {
    if (
      data.segment !== '' &&
      data.customer !== '' &&
      data.name !== '' &&
      data.name.trim().length > 0 &&
      data.name.length < 31 &&
      data.designation !== '' &&
      data.designation.length < 31 &&
      data.designation.trim().length > 0 &&
      data.email !== '' &&
      data.email.trim().length > 0 &&
      validator.isEmail(data.email) && 
      contactNumber !== '' &&
      contactNumber.length > 11 
    ) {
      dispatch(AppActions.showLoader());
      setNameError('');
      setDesignationError('');
      setEmailError('');
      setContactError('');
      setSegmentError('');
      setCustomerError('');

      const body = {
        name: data.name,
        designation: data.designation,
        email: data.email,
        contactNumber: contactNumber,
        segmentId: data.segment,
        customerId: data.customer
      };

      createStakeHolder(body)
        .then(() => {
          reset();
          setContactNumber('');
          setSelectedOption('');
          setCustomerValue('');
          setSnackBarMessage('You have created a stakeholder successfully.');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          getData();
          toggle();
          dispatch(AppActions.hideLoader());
        })
        .catch((error) => {
          dispatch(AppActions.hideLoader());
          setSnackBarMessage( error?.request?.response ? error?.request?.response : 'Unable create a stakeholder');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
        });
    } if (data.segment === '') {
      setSegmentError('Segment is required.');
    } if (data.customer === '') {
      setCustomerError('Client is required.');
    } if (data.name === '') {
      setNameError('Stakeholder name is required.');
    } else if (data.name.trim().length < 1) {
      setNameError('Stakeholder name cannot be only spaces');
    } if (data.designation === '') {
      setDesignationError('Designation is required.');
    } else if (data.designation.trim().length < 1) {
      setDesignationError('Designation cannot be only spaces');
    } if (data.email === '') {
      setEmailError('Email is required.');
    } else if (data.email.trim().length < 1) {
      setEmailError('Email cannot be only spaces');
    } 
    if (contactNumber === '') {
      setContactError('Contact number is required.');
    } else if (contactNumber.trim().length < 1) {
      setContactError('Contact cannot be only spaces');
    }else if (contactNumber.trim().length < 12) {
      setContactError('Contact Number must not be less than 10 numbers.');
    } else if (!validator.isEmail(data.email)) {
      setEmailError('Invalid email address.');
    }
  };

  const containsText = (text, searchText) =>
  text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
    

  const [selectedOption, setSelectedOption] = useState('');
  const [searchText, setSearchText] = useState('');

  const displayedOptions = useMemo(
    () =>
      segments.length > 0 &&
      segments?.filter((option) => containsText(option.name, searchText)),
    [searchText, segments]
  );

  const displayedCustomers = useMemo(
    () =>
    segment && customers?.length > 0 &&
    customers?.filter((option) => {      
      return containsText(option.name, searchText)
    }
    ),
    [searchText, customers]
  );

  const [customerValue, setCustomerValue] = useState('');

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid item xs={12} sx={{ pt: 3, pb: 1, pl: 2 }}>
        <Typography style={{ fontSize: '15px' }} variant="h3">
          Create New Stakeholder
        </Typography>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography style={LabelStyle} fontWeight="light" variant="h5">
            Segment<span style={{ color: 'red' }}>*</span>
          </Typography>
          <Select
            MenuProps={{ autoFocus: false }}
            labelId="search-select-label"
            {...register('segment', {})}
            style={{
              height: '2.25rem',
              width: '94%',
              marginLeft: 15,
              marginTop: 5,
              paddingRight: 15,
              fontSize: '13px'
            }}
            id="add-segmentName"
            displayEmpty
            defaultValue=""
            value={selectedOption || ''}
            onChange={(e) => {
              setSelectedOption(e.target.value);
              setSegment(e.target.value);
              if(e.target.value) {
                setSegmentError('')
              }
            }}
            onClose={() => setSearchText('')}
          >
            <ListSubheader>
              <TextField
                id="add-segmentNameSearch"
                size="small"
                // Autofocus on textfield
                autoFocus
                placeholder="Type to search..."
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key !== 'Escape') {
                    // Prevents autoselecting item while typing (default Select behaviour)
                    e.stopPropagation();
                  }
                }}
              />
            </ListSubheader>
            <MenuItem style={{ display: 'none' }} selected disabled value={''}>
              Select Segment
            </MenuItem>
            {displayedOptions.length > 0 &&
              displayedOptions?.map((option, i) => (
                <MenuItem key={i} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
          </Select>
          <Typography
            style={{
              paddingLeft: 15,
              paddingRight: 15,
              fontSize: '11px'
            }}
            color="red"
          >
            {segmentError}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography style={LabelStyle} fontWeight="light" variant="h5">
            Client <span style={{ color: 'red' }}>*</span>
          </Typography>
          <Select
            id="add-customerName"
            MenuProps={{ autoFocus: false }}
            labelId="search-select-label"
            className="select-text"
            size="small"
            style={selectStyle}
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
            {...register('customer', {})}
            defaultValue={''}
            value={customerValue || ''}
            onChange={(e) => {
              setCustomerValue(e.target.value);
              if(e.target.value) {
                setCustomerError('')
              }
            }}
            onClose={() => setSearchText('')}
          >
            <ListSubheader>
              <TextField
               id="add-customerNameSearch"
               size="small"
               autoFocus
               placeholder="Type to search..."
               fullWidth
               InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== 'Escape') {
                  e.stopPropagation();
                }
              }}
              ></TextField>
            </ListSubheader>
            <MenuItem style={{ display: 'none' }} selected disabled value={''}>
              {!segment
                ? 'Select a segment first'
                : segment && customers?.length === 0
                ? 'No clients in this segment'
                : 'Select client'}
            </MenuItem>
            {displayedCustomers?.length > 0 &&
              displayedCustomers?.map((option, i) => (
                <MenuItem key={i} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
          </Select>
          <Typography
            style={{
              paddingLeft: 15,
              paddingRight: 15,
              fontSize: '11px'
            }}
            color="red"
          >
            {customerError}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography style={LabelStyle} fontWeight="light" variant="h5">
            Stakeholder Name<span style={{ color: 'red' }}>*</span>
          </Typography>
          <TextField
            id="add-stakeholderName"
            inputProps={{ maxLength: 30 }}
            size="small"
            {...register('name', {})}
            style={TextFieldStyle}
            fullWidth
            placeholder="Enter Stakeholder Name"
            variant="outlined"
            onChange={(e) => {
              if (e.target.value.length > 30) {
                setNameError('Stakeholder name must not exceed 30 characters');
              } else {
                setNameError('');
              }
            }}
          />
          <Typography
            style={{
              paddingLeft: 15,
              paddingRight: 15,
              fontSize: '11px'
            }}
            color="red"
          >
            {nameError}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography style={LabelStyle} fontWeight="light" variant="h5">
            Designation<span style={{ color: 'red' }}>*</span>
          </Typography>
          <TextField
            id="stakeholderDesignation"
            inputProps={{ maxLength: 30 }}
            size="small"
            {...register('designation', {})}
            style={TextFieldStyle}
            fullWidth
            placeholder="Enter Designation"
            variant="outlined"
            onChange={(e) => {
              if (e.target.value.length > 30) {
                setDesignationError(
                  'Client name must not exceed 30 characters'
                );
              } else {
                setDesignationError('');
              }
            }}
          />
          <Typography
            style={{
              paddingLeft: 15,
              paddingRight: 15,
              fontSize: '11px'
            }}
            color="red"
          >
            {designationError}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography style={LabelStyle} fontWeight="light" variant="h5">
            Email<span style={{ color: 'red' }}>*</span>
          </Typography>
          <TextField
            id="stakeholderEmail"
            size="small"
            {...register('email', {})}
            style={TextFieldStyle}
            fullWidth
            placeholder="Enter Email"
            variant="outlined"
            autoComplete="new-password"
            onChange={(e) => {
              if(e.target.value) {
                setEmailError('')
              }
            }}
          />
          <Typography
            style={{
              paddingLeft: 15,
              paddingRight: 15,
              fontSize: '11px'
            }}
            color="red"
          >
            {emailError}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography style={LabelStyle} fontWeight="light" variant="h5">
            Contact Number<span style={{ color: 'red' }}>*</span>
          </Typography>
          <MuiPhoneNumber
            id="stakeholderContactNumber"
            defaultCountry={'lk'}
            size="small"
            {...register('contact', {})}
            InputProps={{
              style: { fontSize: '12px', height: '2.25rem' }
            }}
            style={TextFieldStyle}
            fullWidth
            type="text"
            placeholder="Enter Contact Number"
            variant="outlined"
            value={contactNumber}
            onChange={(e) => {
              setContactNumber(e);
              if (e.length > 11) {
                setContactError('');
              }
            }}
          />
          <Typography
            style={{
              paddingLeft: 15,
              paddingRight: 15,
              fontSize: '11px'
            }}
            color="red"
          >
            {contactError}
          </Typography>
        </Grid>
        <Grid
          item
          sx={{
            mb: 2,
            mt: 2,
            pr: 2,
            display: 'flex',
            justifyContent: 'flex-end'
          }}
          xs={12}
        >
          <Button
            id="btn-onClose"
            sx={{
              width: '10%',
              fontWeight: 'normal',
              background: '#F5F7FF',
              fontSize: '13px'
            }}
            onClick={() => {
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button
            id="btn-onSubmit"
            disabled={isLoading}
            className={isLoading ? 'loading' : ''}
            sx={{
              ml: 2,
              width: '10%',
              fontSize: '13px',
              fontWeight: 'normal',
              background: '#0069E4'
            }}
            variant="contained"
            type="submit"
          >
            Add
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default AddStakeHolder;
